import { StepFrame } from "@/features/onboarding/components/StepFrame";
import { LinksManager } from "@/features/identity/components/LinksManager";
import { MediaUploader } from "@/features/identity/components/MediaUploader";
import { useSectionForm } from "@/features/identity/hooks/useSectionForm";
import { useLinksEditor } from "@/features/identity/hooks/useLinksEditor";

export function FormStep({ step, section, onBack, onNext }) {
  const form = useSectionForm(section);
  const { Component } = section;
  const next = async () => {
    if (await form.submit({ force: true })) onNext();
  };
  return (
    <StepFrame step={step} onBack={onBack} onNext={next} busy={form.status.state === "saving"} status={form.status}>
      <Component form={form} />
    </StepFrame>
  );
}

export function LinksStep({ step, onBack, onNext }) {
  const editor = useLinksEditor();
  const next = async () => {
    if (await editor.save()) onNext();
  };
  const label = editor.rows.length ? "Save & continue" : "Skip for now";
  return (
    <StepFrame step={step} onBack={onBack} onNext={next} nextLabel={label} busy={editor.status.state === "saving" || editor.load.status === "loading"} status={editor.status}>
      <LinksManager editor={editor} />
    </StepFrame>
  );
}

export function MediaStep({ step, onBack, onNext }) {
  return (
    <StepFrame step={step} onBack={onBack} onNext={onNext} nextLabel="Continue">
      <div className="space-y-8 rounded-lg border border-border bg-card p-6 sm:p-8">
        <MediaUploader kind="photo" />
        <div className="h-px bg-border" />
        <MediaUploader kind="logo" />
      </div>
    </StepFrame>
  );
}
